import { useState, useEffect } from "react";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { Button } from ".";

const CarouselImageSlider = ({
  slides = [],
  autoSlide = false,
  autoSlideInterval = 5000,
}) => {
  const [curr, setCurr] = useState(0);

  const prev = () =>
    setCurr((curr) => (curr === 0 ? slides.length - 1 : curr - 1));
  const next = () =>
    setCurr((curr) => (curr === slides.length - 1 ? 0 : curr + 1));

  useEffect(() => {
    if (!autoSlide) return;
    const slideInterval = setInterval(next, autoSlideInterval);
    return () => clearInterval(slideInterval);
  }, [autoSlide, autoSlideInterval, curr]);

  return (
    <div className="relative flex overflow-hidden bg-primary/80 rounded-2xl w-full h-[280px] md:h-[220px]">
      {/* Slide Wrapper (Moves Everything Together) */}
      <div
        className="flex transition-transform ease-out duration-500 h-full w-full"
        style={{ transform: `translateX(-${curr * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`w-full ${
              slide.bg ? slide.bg : ""
            } flex-shrink-0 flex md:flex-row flex-col items-center`}
          >
            {/* Left Content */}
            <div className="w-full md:w-[60%] p-6 md:p-8 flex flex-1 flex-col justify-center">
              <h2 className="text-headline4 font-nunito font-bold text-secondary/95 mb-3">
                {slide.title}
              </h2>
              <p className="text-body1 text-secondary/80">{slide.subtitle}</p>
            </div>

            {/* Right Image - Improved Scaling */}
            <div className="hidden md:flex w-full md:w-[40%] flex flex-1 justify-center items-center">
              <img
                src={slide.image}
                onError={(e) => {
                  if (
                    e.target.src !==
                    `https://dummyimage.com/600x400/9DD257/000000&text=Image+Not+Available`
                  ) {
                    e.target.src = `https://dummyimage.com/600x400/9DD257/000000&text=Image+Not+Available`;
                  }
                }}
                crossOrigin="anonymous"
                alt={`Slide ${index}`}
                className="max-h-full !object-contain  h-fit"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Right Controls */}
      <div className="absolute bottom-4 right-4 flex items-center gap-2">
        <Button
          variant="default"
          size="sm"
          onClick={prev}
          className="border-2 border-background h-10 w-10 flex items-center justify-center"
        >
          <IoIosArrowBack />
        </Button>
        <Button
          variant="default"
          size="sm"
          onClick={next}
          className="border-2 border-background h-10 w-10 flex items-center justify-center"
        >
          <IoIosArrowForward />
        </Button>
      </div>

      {/* Dots Indicator */}
      <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-1">
        {slides.map((_, i) => (
          <div
            key={i}
            className={`w-2 h-2 rounded-full cursor-pointer ${
              curr === i
                ? "bg-secondary scale-125"
                : "bg-secondary/40 hover:bg-secondary/80"
            }`}
            onClick={() => setCurr(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default CarouselImageSlider;
